import { useMemo } from 'react';
import useEvent from './useEvent';

var noop = function noop() {};

var createKeyPredicate = function createKeyPredicate(keyFilter) {
  return typeof keyFilter === 'function' ? keyFilter : typeof keyFilter === 'string' ? function (event) {
    return event.key === keyFilter;
  } : keyFilter ? function () {
    return true;
  } : function () {
    return false;
  };
};

var useKey = function useKey(key, fn, opts, deps) {
  if (fn === void 0) {
    fn = noop;
  }

  if (opts === void 0) {
    opts = {};
  }

  if (deps === void 0) {
    deps = [key];
  }

  var _a = opts.event,
      event = _a === void 0 ? 'keydown' : _a,
      target = opts.target,
      options = opts.options;
  var useMemoHandler = useMemo(function () {
    var predicate = createKeyPredicate(key);

    var handler = function handler(handlerEvent) {
      if (predicate(handlerEvent)) {
        return fn(handlerEvent);
      }
    };

    return handler;
  }, deps);
  useEvent(event, useMemoHandler, target, options);
};

export default useKey;